import { Injectable, APP_ID } from '@angular/core';
import * as firebase from 'firebase';
import { Observable, Subscription, TimeoutError } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { admin } from 'firebase-admin/lib/database';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  graphs = [
    {
      graph: 'CA HT Boost',
      Titre: "Chiffre d'affaire total hors taxe",
      api: 'Db_Total_CA_HT',
      source: "presta",
      type: 'number',
      multi: true
    },
    {
      graph: 'CA HT Total',
      Titre: "Chiffre d'affaire total hors taxe",
      api: 'Db_Total_CA_HT',
      source: "presta",
      type: 'number',
      multi: true
    },
    {
      graph: 'CA HT Total (bois)',
      Titre: "Chiffre d'affaire total hors taxe (bois/metal)",
      api: 'Db_Total_CA_HT_Bois',
      source: "presta",
      type: 'number',
      multi: true
    },
    {
      graph: 'CA HT Total (graph)',
      Titre: "Chiffre d'affaire total hors taxe",
      api: 'Db_Total_CA_HT_Cumul',
      source: "presta",
      type: 'graph',
      multi: true
    },
    {
      graph: 'CA HT Total (graph bois)',
      Titre: "Chiffre d'affaire total hors taxe (bois/metal)",
      api: 'Db_Total_CA_HT_Cumul_Bois',
      source: "presta",
      type: 'graph',
      multi: true
    },
    {
      graph: 'CA HT Etat',
      Titre: "Chiffre d'affaire total hors taxe (trier par état)",
      api: 'Db_Total_CA_HT_Etat',
      source: "presta",
      type: 'number',
      multi: true
    },
    {
      graph: 'Commandes annulées-remboursées',
      Titre: "Commandes annulées/remboursées  ",
      api: "Db_Total_Order_Canceled",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      graph: 'Nouveau Clients',
      Titre: "Nouveaux clients",
      api: "Db_Total_New_Customer",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      graph: 'Total de commandes',
      Titre: "Total de commandes",
      api: "Db_Total_Order",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      graph: 'Total de commandes (graph)',
      Titre: "Nombre total de commandes",
      api: "Db_Total_Order_Cumul",
      source: "presta",
      type: "graph",
      multi: true
    },
    {
      graph: 'Panier Moyen HT',
      Titre: "Panier moyen hors taxes",
      api: "Db_Average_Cart_HT",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      graph: 'Total boosts',
      Titre: "Total commandes boost",
      api: "Db_Priority",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      Titre: "Total de commandes bois",
      graph: "Total commandes bois",
      api: "Db_Total_Order_Bois",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      Titre: "Utilisateur venant des réseaux sociaux",
      graph: "Utilisateur venant de RS",
      api: "ga:users",
      dimension: "ga:socialNetwork",
      filter: "ga:socialNetwork!=(not set)",
      source: "GA",
      type: "number",
      multi: true
    },
    {
      Titre: "Visite totale",
      graph: "Visite totale",
      api: "ga:users",
      dimension: "",
      filter: "",
      source: "GA",
      type: "number",
      multi: true
    },
    {
      Titre: "Visite par source",
      graph: "Visite par source",
      api: "ga:users",
      dimension: "ga:channelGrouping",
      filter: "",
      source: "GA",
      type: "number",
      multi: true
    },
    {
      Titre: "Visite par pays",
      graph: "Visites (pays)",
      api: "ga:users",
      dimension: "ga:country",
      filter: "ga:continent==Europe",
      source: "GA",
      type: "map",
      multi: true

    },
    {
      Titre: "Visite par pays",
      graph: "Visites (pays)",
      api: "ga:users",
      dimension: "ga:country",
      filter: "ga:continent==Europe",
      source: "GA",
      type: "map",
      multi: true
    },
    {
      Titre: "Total colis expédié",
      graph: "Total Colis",
      api: "Db_Total_Box",
      source: "presta",
      type: "number",
      multi: false
    },
    {
      Titre: "Taille des colis expédiés",
      graph: "Taille colis",
      api: "Db_Total_Box_Dimensions",
      source: "presta",
      type: "number",
      multi: false
    },
    {
      Titre: "Total expédition",
      graph: "Total expedition",
      api: "Db_Total_Box_Dimensions",
      source: "presta",
      type: "number",
      multi: false
    },
    {
      Titre: "Progression des expéditions",
      graph: "Données des expéditions",
      api: "Db_Shipping_Datas",
      source: "presta",
      type: "number",
      multi: true
    },
    {
      Titre: "CA HT (trier par état)",
      graph: "CA HT Etat",
      api: "Db_Total_CA_HT_Etat",
      source: "presta",
      type: "number",
      multi: true
    }
  ]


  constructor(private httpClient: HttpClient) { }

  createNewUser(email: string, password: string, name: string, service: string, profil: string) {
    return new Promise(
      (resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(email, password).then(
          () => {
            resolve();
            this.setUser(name, service, profil);
          },
          (error) => {
            reject(error);
          }
        );
      }
    );
  }

  async signInUser(email: string, password: string) {
    return new Promise<boolean>(
      (resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(email, password).then(
          () => {
            resolve(true);
          },
          (error) => {
            reject(error);
          }
        );
      }
    )
  }

  signOutUser() {
    firebase.auth().signOut();
    location.reload();
  }

  /** 
 * Initiate the password reset process for this user 
 * @param email email of the user 
 */
  resetPasswordInit(email: string) {
    return firebase.auth().sendPasswordResetEmail(
      email,
      { url: 'http://localhost:4200/auth' });
  }


  setUser(name: string, service: string, profil: string) {
    var user = firebase.auth().currentUser;
    var email, uid;
    var charts = ""
    this.graphs.forEach(element => {
      charts += element.graph + '_'
    });
    if (user != null) {
      email = user.email;
      uid = user.uid;
    }
    user.updateProfile({
      displayName: name,
    }).then(() => {
      firebase.database().ref('users/' + uid).update({
        name: name,
        email: email,
        service: service,
        profil: profil,
        actif: true,
        date_start: "19-12-01",
        date_end: "19-12-31"
      });
      firebase.database().ref('PageConfig/Profil/' + uid).update({
        date_start: "19-12-01",
        date_end: "19-12-31"
      });
      firebase.database().ref().child('service').child(service + '/' + uid).update({
        mail: email,
        actif: true
      });
      firebase.database().ref().child('Profil').child(profil + '/' + uid).update({
        mail: email,
        actif: true
      });
      this.graphs.forEach(element => {
        firebase.database().ref().child('PageConfig/Profil').child(uid + '/Charts/' + element.graph).update({
          actif: true,
          height: 200,
          left: 0,
          top: 0,
          width: 400,
          type: 'line',
          config: {
            Titre: element.Titre,
            api: element.api,
            type: element.type,
            source: element.source
          }

        });
      });
      firebase.database().ref('PageConfig/Profil/' + uid + "/Charts").update({
        actifs: "",
        inactifs: charts
      });

      console.log('Nouvel utilisateur enregistré : nom :' + name + ', ID : ' + uid);
    }).catch(function (error) {
      console.log('erreur : ' + error);
    });
  }

  getName() {

    var user = firebase.auth().currentUser;
    if (user != null) {
      return user.displayName;
    }
  }

  async getService() {

    var user = firebase.auth().currentUser;
    var serviceRef = firebase.database().ref('users/' + user.uid + '/service');
    var val = await serviceRef.once('value');
    var res = val.val();
    localStorage.setItem('service', (res));

  }

  async isAdmin() {
    var user = firebase.auth().currentUser;
    var ref = firebase.database().ref("Profil/admin");
    var val = await ref.once("value");
    var res = val.child(user.uid).exists();
    return res
  }

  saveUsersToServer(service: string, name: string, id: string) {

    firebase.database().ref().child('service').child(service).update({
      [id]: name,
    });
  }

}
